import { gql } from 'types/__generated__/gql';

const KEY_CURRICULUM_PROGRESS_ASYNC_QUERY = gql(/* GraphQL */ `
  query getCurriculumProgressReportAsync($where: KeyReportWhereInput!) {
    keyCurriculumProgressReportAsync(where: $where) {
      id
      error
      result {
        curriculumProgressPercentage
      }
    }
  }
`);

export default KEY_CURRICULUM_PROGRESS_ASYNC_QUERY;
